import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Form, Schema } from 'rsuite';
import Swal from 'sweetalert2';
import reinstatementService from '../../../../../../services/Public/Reinstatement/PLS/plsReinstatement.service';
import Information from '../../../../../Shared/Card/Information';
import Issues from '../../../../../Shared/Card/Issues';
import FormActionButtons from '../../../../../Shared/FormAction/FormActionButtons'
import LoadingSpinner from '../../../../../Shared/GenericComponents/LoadingSpinner';
import { GetReinstatementInformationContent } from '../../../../../Shared/InformationContent/PlsInformation';
import Courses from './Courses'

function CpdRequirementsPage() {
    const push = useNavigate();
    const [formModel, setFormModel] = useState({
        electronicSignature: "",
        hasCpd: ''
    });
    const reinstatementId = useSelector(x => x.currentApplicationId);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [hasFiles, setHasFiles] = useState(false);
    const sectionId = 5;
    const routes = useSelector(x => x.currentRoutes);
    const { StringType, BooleanType } = Schema.Types;
    const model = Schema.Model({
        electronicSignature: StringType().isRequired('This field is required.'),
    });
    useEffect(() => {
        reinstatementService.plsGetSection(reinstatementId, sectionId).then((response) => {
            setFormModel(response.data);
            setHasLoaded(true);
        })
    }, [])
    const formSubmit = () => {
        if (hasFiles) {
            reinstatementService.plsPostCpdComment(reinstatementId, sectionId, formModel.cpdComment).then((result) => {
                reinstatementService.plsPostSection(reinstatementId, sectionId, formModel.electronicSignature).then((response) => {
                    if (response.data.id) {
                        nextSectionNavigation()
                    }
                })
            })
        }
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route);
    }
    return (
        <div>
            <Container fluid>
                <strong>Professional Land Surveyor Reinstatement</strong>
                <h4 className="mb-3">
                    CPD Requirements
                </h4>
                <Information content={GetReinstatementInformationContent("cpdRequirements")} />
                <br />
                {hasLoaded ?
                    <Form readOnly={!formModel.isUserEditable} model={model} formValue={formModel} onChange={formModel => setFormModel(formModel)} onSubmit={formSubmit} fluid>
                        <Courses
                            formModel={formModel}
                            setHasFiles={setHasFiles}
                            hasFiles={hasFiles} />
                        <br />
                        <Issues isUserEditable={true} type={2} sectionId={formModel.id} />
                        <FormActionButtons nextSectionCallback={nextSectionNavigation} isReadOnly={!formModel.isUserEditable} backToSectionLink="/individual/plsReinstatement/sections" />
                    </Form> : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}

export default CpdRequirementsPage